<app-navbar></app-navbar>

<!-- Start Page Title Area -->
<div class="page-title-area page-title-bg2">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>Projects</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Projects</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="shape-img2"><img src="assets/img/shape/shape2.svg" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.svg" alt="image"></div>
    <div class="shape-img4"><img src="assets/img/shape/shape4.png" alt="image"></div>
    <div class="shape-img5"><img src="assets/img/shape/shape5.png" alt="image"></div>
    <div class="shape-img7"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape-img8"><img src="assets/img/shape/shape8.png" alt="image"></div>
    <div class="shape-img9"><img src="assets/img/shape/shape9.png" alt="image"></div>
    <div class="shape-img10"><img src="assets/img/shape/shape10.png" alt="image"></div>
</div>
<!-- End Page Title Area -->

<!-- Start Projects Area -->
<section class="projects-area ptb-100">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-projects-box">
                    <img src="assets/img/projects-image/projects1.jpg" alt="image">
                    <div class="projects-content">
                        <h3><a routerLink="/project-details">Digital Marketing</a></h3>
                        <span class="category">Design</span>
                    </div>
                    <div class="plus-icon">
                        <a href="assets/img/projects-image/projects1.jpg" class="popup-btn">
                            <span></span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-projects-box">
                    <img src="assets/img/projects-image/projects2.jpg" alt="image">
                    <div class="projects-content">
                        <h3><a routerLink="/project-details">Design & Development</a></h3>
                        <span class="category">Planing</span>
                    </div>
                    <div class="plus-icon">
                        <a href="assets/img/projects-image/projects2.jpg" class="popup-btn">
                            <span></span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-projects-box">
                    <img src="assets/img/projects-image/projects3.jpg" alt="image">
                    <div class="projects-content">
                        <h3><a routerLink="/project-details">Strategic Planing</a></h3>
                        <span class="category">Marketing</span>
                    </div>
                    <div class="plus-icon">
                        <a href="assets/img/projects-image/projects3.jpg" class="popup-btn">
                            <span></span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-projects-box">
                    <img src="assets/img/projects-image/projects4.jpg" alt="image">
                    <div class="projects-content">
                        <h3><a routerLink="/project-details">SEO Consultancy</a></h3>
                        <span class="category">Development</span>
                    </div>
                    <div class="plus-icon">
                        <a href="assets/img/projects-image/projects4.jpg" class="popup-btn">
                            <span></span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-projects-box">
                    <img src="assets/img/projects-image/projects5.jpg" alt="image">
                    <div class="projects-content">
                        <h3><a routerLink="/project-details">Competitor Analysis</a></h3>
                        <span class="category">Design</span>
                    </div>
                    <div class="plus-icon">
                        <a href="assets/img/projects-image/projects5.jpg" class="popup-btn">
                            <span></span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-projects-box">
                    <img src="assets/img/projects-image/projects6.jpg" alt="image">
                    <div class="projects-content">
                        <h3><a routerLink="/project-details">Social Media Marketing</a></h3>
                        <span class="category">Development</span>
                    </div>
                    <div class="plus-icon">
                        <a href="assets/img/projects-image/projects6.jpg" class="popup-btn">
                            <span></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Projects Area -->